import React from 'react';
import styled from 'styled-components';
import { Table, TableHeader, TableData } from 'components/styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import join from 'lodash/join';
import shortid from 'shortid';

const PrescreenInfo = ({ instance }) => (
  <Table>
    <tbody>
      <TableRow>
        <TableHeader>Question</TableHeader>
        <TableHeader>Answer</TableHeader>
      </TableRow>

      {map(instance, entry => (
        <TableRow key={shortid.generate()}>
          <TableData>{entry.question}</TableData>
          <TableData>
            {join(
              map(entry.answers.filter(a => a.selected), a => a.answer),
              ','
            )}
          </TableData>
        </TableRow>
      ))}
    </tbody>
  </Table>
);

const TableRow = styled.tr`
  border-bottom: 1px solid ${colors.lightestGray};
  background: ${props => props.background || '#fff'};
  &:last-child {
    border-bottom: none;
  }
`;

export default PrescreenInfo;
